export const CALENDAR_DAY_LOAD_PENDING = { dayLoad: null, isFailed: false }
